import tagTester from './_tagTester.js';

export default tagTester('Symbol');



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.8@underscore/modules/isSymbol.js
// module id = 343
// module chunks = 115